// 引入axiox
import axios from 'axios'
import api from './baseurl.js'
import router from '../router'


// 创建axios实例
const http = axios.create({
    baseURL:`${api.fayongApi}`,
    timeout: 9000
})

// 请求拦截器
http.interceptors.request.use(function (config) {
    let tokenStr='';
    if(localStorage.getItem('token') != null) {
        tokenStr = localStorage.getItem('token');
    }
    config.headers['token'] = tokenStr;
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})

// 响应拦截器
http.interceptors.response.use(function (result) {
    // 判断成功
    const { status, data } = result
    // 判断接口返回状态
    if (status === 200) {
        // 如果接口正常则返回接口给的数据
        return data
    } else {
        // 如果不正常则返回一个错误信息
        return Promise.reject('系统未知错误，请反馈给管理员')
    }
}, function (error) {
    if(error.response && error.response.status === 401){
        alert('登录已过期，请重新登录');
        router.push( '/login' )
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
    }else{
        // 返回错误信息
         return Promise.reject(error)
    }
    
})


export default http
